import * as e from "react";
import { forwardRef as r } from "react";
const n = r(function(C, o) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: o,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...C
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M13.61 14.8711C13.5924 14.8711 12.8886 14.8711 12.1671 14.8711C11.4633 14.8711 10.7244 14.8711 10.5835 14.8711H10.5484C10.5484 14.8897 10.5484 14.9082 10.5484 14.9268V19.6841C10.5484 19.7212 10.5484 19.7585 10.5308 19.7956C10.5132 19.9257 10.39 20 10.2844 20H6.3431C6.30793 20 6.27277 20 6.23753 19.9815C6.09678 19.9442 6.00882 19.8514 6.00882 19.7212C6.00882 19.7027 6.00882 19.7027 6.00882 19.7027C6.00882 19.6841 6.00882 19.6655 6.00882 19.6655V13.626V13.5703H3.10558C3.08796 13.5703 3.05279 13.5703 3.03517 13.5517C3 13.5331 3 13.496 3 13.4588L3.01762 13.4031C3.03517 13.3845 3.05279 13.3473 3.07041 13.3287L11.8856 4.09297C11.9208 4.05575 11.9736 4.01861 12.0088 4.01861C12.044 4 12.0616 4 12.0968 4C12.1671 4 12.2375 4.03722 12.3079 4.07436L12.3959 4.16726L20.9296 13.3287C20.9472 13.3473 20.9472 13.3845 20.9648 13.4031L21 13.4402C21 13.4588 21 13.4774 21 13.496C21 13.5331 20.9824 13.5517 20.9472 13.5703C20.912 13.5703 20.8944 13.5703 20.8593 13.5703H18.1319H18.0791V13.5889V13.6075C18.0616 13.7561 18.0616 13.7561 18.0616 19.6655V19.7398C18.044 19.8885 17.9384 19.9815 17.8153 20H13.8563C13.7331 19.9629 13.6275 19.8514 13.61 19.7212V14.8711Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  n as Home
};
